import { render, staticRenderFns } from "./Contatti.vue?vue&type=template&id=23e640d2&"
import script from "./Contatti.vue?vue&type=script&lang=js&"
export * from "./Contatti.vue?vue&type=script&lang=js&"
import style0 from "./Contatti.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports